/* 🤖 this file was generated by svg-to-ts */
export const iconTick: {
    name: 'tick';
    data: string;
} = {
    name: 'tick',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18"><path fill="#000" fill-rule="evenodd" d="M20.4.562a.7.7 0 0 1 1.174.758l-.056.087-12.12 16.03a.7.7 0 0 1-.975.142l-.08-.069L.547 9.712a.7.7 0 0 1 .903-1.063l.087.073 7.229 7.23z"/></svg>`
};
